export default monitor => {
  return {
    nameOrUrl: monitor.name ? monitor.name : monitor.url,
    ...monitor
  }
}
